<template>
  <div>
    <template v-if="!isLoading">
      <b-avatar
        size="35px"
        variant="primary"
        :badge-variant="userInfo.variant"
        :text="userInfo.userInitials"
        :src="userInfo.avatar"
        :id="`datatable-avatar-${userInfo.id}-${_uid}`"
      ></b-avatar>
      <b-popover
        :target="`datatable-avatar-${userInfo.id}-${_uid}`"
        triggers="hover focus"
        boundary="viewport"
        placement="top"
      >
        <div class="text-center">
          <strong>{{ userInfo.name }}</strong> <br>
          {{ date }}
        </div>
      </b-popover>
    </template>
    <b-skeleton type="avatar" v-else></b-skeleton>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      userInfo: null
    }
  },
  computed: {
    date () {
      if (this.value?.date) {
        return moment(this.value.date).format('DD-MM-YYYY HH:mm')
      }
      return null
    }
  },
  methods: {
    async loadUserInfo () {
      const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${this.value.user}`)
      this.userInfo = {
        id: res.data.id,
        name: `${res.data.firstname} ${res.data.lastname}`,
        userInitials: res.data?.userInitials,
        avatar: res.data?.profilePicture || ''
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      await this.loadUserInfo()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
